import { useContext } from 'react';

import { KeepMountedContext } from '../contexts/KeepMountedContext.js';

/** @internal */
export const useKeepMountedContext = () => useContext(KeepMountedContext);
